module.exports = __webpack_public_path__ + "media/tuinenmeer-rtl4-hq.dfde2350.mp4";